<div>
  <div class="app-expansion-panel-container">
    <igo-backdrop [shown]="backdropShown()" (click)="onBackdropClick()" />

    <app-expansion-panel-header [(expanded)]="expanded">
      <ng-content select="[expansionPanelHeader]" />
    </app-expansion-panel-header>

    <div
      class="app-expansion-panel-content mat-elevation-z4"
      [@showContent]="expanded()"
    >
      <ng-content />
    </div>
  </div>
</div>
